// extracted by mini-css-extract-plugin
export default {"hero":"Hero2_hero__XCtRP","images":"Hero2_images__N9GOm","image":"Hero2_image__dW6s1","textOverlay":"Hero2_textOverlay__IlE+y","title":"Hero2_title__6qY3F"};